export default __webpack_public_path__ + "static/media/Favourite pic - 214 SUBHAYAN DAS.a9f0664d.jpg";